import { Button } from '@teach/ui'
import { useAppDispatch } from '@/store/hooks'
import { langSlot } from '@/features/ai/images/lib/targetKeys'
import type { StudioJob } from '@/features/ai/studioTypes'
import { setDialogOpen, setDrawImagesSlot } from '@/features/editor/editorSlice'
import { useMessages } from '@/i18n'
import { messages } from './sidebarMessages'

/**
 * Четвёртая ветка цепочки §7.4: перевод прошёл, а картинки второго языка бэк
 * не поставил. Текст — ДОСЛОВНО серверный (`translationImagesNotice`), своего
 * не сочиняем.
 *
 * Действие ОДНО, и это осознанно. Контракт различает две причины («не хватило
 * кредитов» и «картиночный воркфлоу не разбудили») только словами внутри
 * сообщения — отдельного кода нет, а разбирать русскую фразу подстрокой
 * запрещено (CLAUDE.md). Поэтому кнопка ведёт в ручной старт отрисовки: если
 * причина всё-таки в деньгах, автор упрётся в отказ старта и получит кнопку
 * пополнения от общего баннера отказов — путь закрыт в обоих случаях без
 * гадания по тексту.
 *
 * Отдельного компонента этот кусок стоит только по одной причине: `RunOutcome`
 * остаётся чистым (props in → JSX out), а стор нужен именно здесь.
 */
interface Props {
  message: string
  /** Язык, НА который переводили: у английского курса это `ru`, и его картинки
   *  лежат в базовой колонке. Слот берётся из данных прогона, а не константой —
   *  иначе автор английского курса платил бы за отрисовку чужого слота. */
  targetLang: StudioJob['target_lang']
}

export const TranslationImagesNotice = ({ message, targetLang }: Props) => {
  const m = useMessages(messages)
  const dispatch = useAppDispatch()

  const draw = () => {
    // Слот ставится ПЕРЕД открытием: диалог читает его пропом и открывается
    // сразу в ручном режиме — авто-режим рисует только исходный слот (§5.3).
    dispatch(setDrawImagesSlot(langSlot(targetLang)))
    // Тот же путь открытия, что у кнопки в шапке редактора: диалогом владеет
    // `editorSlice`, второго механизма открытия не заводим.
    dispatch(setDialogOpen({ dialog: 'drawImagesOpen', open: true }))
  }

  return (
    <div className="space-y-2">
      <p data-testid="translation-images-notice" className="text-xs text-muted-foreground">
        {message}
      </p>
      <Button variant="outline" size="sm" onClick={draw}>
        {m.drawImages}
      </Button>
    </div>
  )
}
